import { SIGNUP_CLIENT } from "../constants";
import { SignupClient } from "./index";
import { createHttpClient } from "commons/utils";

export function initSignupClient(app: Common.IApplication): Common.IApplication {
  if (app.isServiceRegistered(SIGNUP_CLIENT)) {
    return app;
  }

  const transport = createHttpClient({
    baseUrl: window.appConfig.signupApiUrl
  });

  return app.registerService(SIGNUP_CLIENT, () => new SignupClient(transport));
}
